import i18next from 'i18next';
import { getApiHost, getFullUrl, getServiceToken } from '@/shared/lib/utils/env';

/**
 * Базовый адрес запросов к бэкенду. Пустой хост означает, что бэкенд отвечает по тому же адресу,
 * что и страница, — тогда запросы идут относительными путями.
 */
export const getApiBaseUrl = (): string => getApiHost() || '/';

/** Заголовки авторизации запроса к бэкенду; сервисного токена может и не быть */
const getApiAuthHeaders = (): Record<string, string> => {
  const serviceToken = getServiceToken();
  return serviceToken ? { Authorization: `Bearer ${serviceToken}` } : {};
};

/**
 * Язык ответа бэкенда — текущий язык интерфейса: на нём бэкенд называет причину отказа. Читается
 * на каждый запрос, поэтому после смены языка следующие отказы приходят уже на новом.
 */
const getApiLanguageHeaders = (): Record<string, string> =>
  i18next.language ? { 'Accept-Language': i18next.language } : {};

/** Заголовки, которые получает каждый запрос к бэкенду — и через `apiClient`, и через `apiFetch` */
export const getApiRequestHeaders = (): Record<string, string> => ({
  ...getApiAuthHeaders(),
  ...getApiLanguageHeaders(),
});

/**
 * Запрос к бэкенду в обход `apiClient`: адрес, заголовки и куки — те же, что клиент подставляет
 * каждому своему запросу, поэтому смена схемы авторизации доходит и сюда. Годится только там, где
 * axios не умеет нужного (`keepalive` у запроса, переживающего уход со страницы); во всех
 * остальных случаях запрос идёт через `apiClient`.
 */
export const apiFetch = (path: string, init: RequestInit): Promise<Response> =>
  fetch(getFullUrl(path), {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...getApiRequestHeaders(), ...init.headers },
  });
